<template>
  <v-app dark>
    <v-app-bar app class="elevation-3 white">
      <v-container class="py-0 fill-height" :class="$vuetify.breakpoint.xs ? 'px-0' : ''">
        <a href="https://retitlesanddeeds.com/" class="d-flex align-center">
          <v-img
            alt="RE Tiltes &amp; Deeds Logo"
            class="shrink mr-2 "
            contain
            src="./assets/logoImage.png"
            transition="scale-transition"
            width="75"
          />

          <v-img
            alt="RE Tiltes &amp; Deeds Name"
            class="shrink"
            contain
            min-width="100"
            transition="scale-transition"
            src="./assets/logoText.png"
            width="200"
          />
        </a>

        <v-spacer></v-spacer>
        <div class="d-none d-sm-flex">
          <v-btn
            text
            v-if="!isAuthenticated"
            class="mr-3"
            to="/new-order"
            color="primary"
            >New Order</v-btn
          >
          <v-btn
            text
            v-if="!isAuthenticated"
            class="mr-3"
            to="/contact-us"
            color="primary"
            >Contact Us</v-btn
          >
          <v-btn
            text
            v-if="!isAuthenticated"
            class="mr-3"
            to="/sign-up"
            color="primary"
            >Sign Up</v-btn
          >
          <v-btn text v-if="!isAuthenticated" to="/login" color="primary"
            >Login</v-btn
          >
        </div>
        <v-menu v-if="!isAuthenticated && $vuetify.breakpoint.xs">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item to="/new-order">
              <v-list-item-title>New Order</v-list-item-title>
            </v-list-item>
            <v-list-item to="/sign-up">
              <v-list-item-title>Sign Up</v-list-item-title>
            </v-list-item>
            <v-list-item to="/login">
              <v-list-item-title>Login</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-container>
    </v-app-bar>
    <v-main v-if="loading">
      <v-container fluid fill-height>
        <v-row align="center" justify="center">
          <v-col cols="auto">
            <v-progress-circular
              indeterminate
              color="primary"
              :size="50"
              :width="4"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-main v-else>
      <router-view />
    </v-main>
    <v-footer>
      <v-row>
        <v-col>
          <span>© {{new Date().getFullYear()}} RE Titles & Deeds, LLC. All Rights Reserved.</span>
        </v-col>
        <v-col align="right">
          <privacy-policy-dialog/> • <terms-of-service-dialog/>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PrivacyPolicyDialog from './components/PrivacyPolicyDialog.vue';
import TermsOfServiceDialog from './components/TermsOfServiceDialog.vue';

export default {
  components: { TermsOfServiceDialog, PrivacyPolicyDialog },
  name: "App",

  data() {
    return {
      loading: true,
      showMobileNav: true,
    };
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    windowTitle() {
      return this.$store.state.windowTitle;
    },
  },

  methods: {
    ...mapActions("auth", ["logout", "getProfile"]),
    ...mapActions("products", ["updateProducts", "updateDocumentTypes"]),
    ...mapActions("states", ["updateStates"]),

    loadInitialData() {
      this.loading = true;
      const requests = [this.updateProducts(), this.updateStates(), this.updateDocumentTypes()]
      if (this.isAuthenticated) {
        requests.push(this.getProfile())
      }
      return Promise.all(requests);
    },
    logoutUser() {
      this.logout().then(() => {
        this.$router.push("/login");
      });
    },
  },

  watch: {
    windowTitle() {
      document.title = `${this.$store.state.windowTitle} | ${this.$store.state.applicationTitle}`;
    },
    isAuthenticated() {
      if (this.$route.path != '/new-order') {
        this.loadInitialData().then(() => {
          this.loading = false;
        });
      }
    },
  },

  mounted() {
    this.loadInitialData().then(() => {
      this.loading = false;
    });
  },
};
</script>

<style scoped>
.theme--light.v-application {
  background: #fafafa;
}
</style>
